
import React, { useEffect } from "react";
import {
  Tabs,
  Tab,
  Box,
  MenuItem,
  Select,
  Typography,
  SvgIcon,
  Popover,
} from "@mui/material";
import Calendar from "../../../src/assests/images/calendar-2.svg";
import TaskAnalysis from "./TaskAnalysis";
import UserAnalysis from "./UserAnalysis";
import OutletsCard from "./OutletsCard";
import UserActivityChart from "./UserActivityChart";
import TaskCompletionChart from "./TaskCompletionChart";
import DashboardDatePicker from "./DashboardDatePicker";
import { getalllocations } from "./api";


const LineArrow = () => (
  <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: "30px" }}>
    <path
      d="M7 10l5 5 5-5"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const DashboardTabPanel = ({ children, value, index, ...other }: any) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);




interface Props {
  location: string;
  setLocation: React.Dispatch<React.SetStateAction<string>>;
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
  dropdownValue: string;
  setDropdownValue: React.Dispatch<React.SetStateAction<string>>;
  tasksummary:[]
  outletsdata:[]
  outletlength:string
  useranalysis:string
  ylabels:[]
  xlabels:[]
  ylabels1:[]
  xlabels1:[]

}

export default function CustomTabs({ location, setLocation, value, setValue,setDropdownValue,dropdownValue,tasksummary,outletsdata,outletlength,useranalysis,ylabels,xlabels,xlabels1,ylabels1}: Props) {

  // const [location, setLocation] = React.useState("All Locations");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const popoverRef = React.useRef<HTMLDivElement>(null); // Ref for the popover

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 4) {
      setAnchorEl(event.currentTarget as HTMLElement); // Open calendar popover
    } else {
      setValue(newValue); // Update tab for non-calendar tabs
    }
  };

  const handleLocationChange = (event: any) => {
    setLocation(event.target.value);
  };

  const isPopoverOpen = Boolean(anchorEl);

  

  const [allcities, setcities] = React.useState([]);


  useEffect(() => {

        const fetchDropdownCities = async () => {
          try {
            const response = await getalllocations();
            console.log(response, "API Response");
  
            const cities = response.data.data;
            console.log(cities, "Cities Data");
  
  console.log(cities, "locationslocationslocations")
  setcities(cities)
            
          } catch (error) {
            console.error("Error fetching cities:", error);
          }
        };
  
        fetchDropdownCities();
 
    }, []);
console.log(allcities, "allcitiessssssssssssssssssaaaaaaaa")
console.log(location, "locationssssssssss")
console.log(useranalysis, "valuevaluevalue222")
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: 1,
          borderColor: "divider",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{ background: "#fff", borderRadius: "10px", overflow: "hidden" }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: "#c8172f",
                borderRight: "1px solid #000",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                borderRight: "1px solid #7D7E7F",
                color: "#7D7E7F",
                fontSize: "16px",
                fontWeight: "300",
                padding: "0 8px",
              },
              "& .MuiTab-root:last-child": { borderRight: "0" },
              "& .Mui-selected": {
                color: "#c8172f !important",
                background: "#FFEBEF",
              },
            }}
          >
            <Tab label="Today" />
            <Tab label="Yesterday" />
            <Tab label="Last 7 Days" />
            <Tab label="Last 6 Months" />
            {/* <Tab
              icon={
                <img
                  src={Calendar}
                  alt="Calendar"
                  style={{ width: "20px", height: "20px" }}
                />
              }
              iconPosition="start"
            /> */}
          </Tabs>
        </Box>
        <Select
          value={location}
          onChange={handleLocationChange}
          displayEmpty
          IconComponent={LineArrow}
          sx={{
            minWidth: 150,
            border: "1px solid #ffffff",
            borderRadius: 1,
            padding: "4px 8px",
            fontSize: "16px",
            height: "44px",
            fontWeight: "600",
          }}
        >
       
          <MenuItem value="All Locations">All Locations</MenuItem>
          {allcities.map((item) => (
    <MenuItem key={item} value={item}>
      {item}
    </MenuItem>
  ))}
        </Select>
      </Box>
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: "400",
          padding: "15px 0",
          color: "#7D7E7F",
        }}
      >
        Analytics of task and user from the task release date till today
      </Typography>
      <DashboardTabPanel value={value} index={0}>
        <TaskAnalysis setDropdownValue={setDropdownValue} dropdownValue={dropdownValue} tasksummary={tasksummary}/>
        <UserAnalysis useranalysis={useranalysis}/>
        <OutletsCard outletsdata={outletsdata} outletlength={outletlength}/>
      </DashboardTabPanel>
      <DashboardTabPanel value={value} index={1}>
        <TaskAnalysis setDropdownValue={setDropdownValue} dropdownValue={dropdownValue} tasksummary={tasksummary}/>
        <UserAnalysis useranalysis={useranalysis}/>
        <OutletsCard   outletsdata={outletsdata} outletlength={outletlength}/>
      </DashboardTabPanel>
      <DashboardTabPanel value={value} index={2}>
        <TaskCompletionChart  xlabels1={xlabels1}  ylabels1={ylabels1}/>
        <UserActivityChart ylabels={ylabels} xlabels={xlabels}/>
        <OutletsCard   outletsdata={outletsdata} outletlength={outletlength}/>
      </DashboardTabPanel>
      <DashboardTabPanel value={value} index={3}>
        <TaskCompletionChart  xlabels1={xlabels1}  ylabels1={ylabels1}/>
        <UserActivityChart ylabels={ylabels} xlabels={xlabels}/>
        <OutletsCard  outletsdata={outletsdata} outletlength={outletlength}/>
      </DashboardTabPanel>

      {/* DatePicker Popup */}
      <Popover
        open={isPopoverOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        ref={popoverRef}
      >
        <DashboardDatePicker />
      </Popover>
    </Box>
  );
}
